var render = function render(){var _vm=this,_c=_vm._self._c;return (
    (_vm.activeTextConfig && _vm.activeTextConfig.text) ||
    (_vm.config && _vm.config.background && _vm.config.background.color) ||
    (_vm.config && _vm.config.background && _vm.config.background.gradient) ||
    (_vm.config && _vm.config.image && _vm.config.image.url)
  )?_c('v-card',{staticClass:"rounded-lg pgm-dashboard-container headline-container d-flex align-center",class:_vm.backgroundClass,style:(_vm.backgroundStyle),attrs:{"elevation":"1"}},[(_vm.activeTextConfig && _vm.activeTextConfig.text)?_c('div',{staticClass:"overlay-text",class:_vm.overlayTextClass,style:(_vm.overlayTextStyle)},[_c('span',[_vm._v(" "+_vm._s(_vm.activeTextConfig.text)+" ")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }